import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";
import Header from "../../../layout/Header/Header";
import Swal from "sweetalert2";
import { puede } from "../../../../permisos/permisos";

function ListadoTurnos() {
  const { user } = useContext(AuthContext);
  const URL_TURNOS = process.env.REACT_APP_URL_TURNOS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [turnos, setTurnos] = useState([]);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [idEdit, setIdEdit] = useState(null);
  const [nombre, setNombre] = useState("");
  const [horaInicio, setHoraInicio] = useState("");
  const [horaFin, setHoraFin] = useState("");

  useEffect(() => { getTurnos(); }, []);
  function getTurnos() {
    axios.get(URL_TURNOS, headers).then((r) => setTurnos(r.data)).catch((e) => console.log(e));
  }

  function abreNuevo() { setIdEdit(null); setNombre(""); setHoraInicio(""); setHoraFin(""); toggle(); }
  function abreEdit(a) {
    setIdEdit(a._id); setNombre(a.nombre); setHoraInicio(a.horaInicio || ""); setHoraFin(a.horaFin || ""); toggle();
  }

  function guardar() {
    const body = { nombre, horaInicio, horaFin };
    const req = idEdit
      ? axios.patch(`${URL_TURNOS}/${idEdit}`, body, headers)
      : axios.post(URL_TURNOS, body, headers);
    req
      .then(() => { toggle(); Swal.fire("Good job!", "Guardado con exito", "success"); window.location.reload(); })
      .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data : error}` }));
  }

  function sembrar() {
    Swal.fire({
      title: "Cargar turnos por defecto?",
      text: "T1 (6-14), T2 (14-21:30), T3 (21:30-6). Solo si no hay turnos.",
      icon: "question", showCancelButton: true, confirmButtonText: "Si, cargar", cancelButtonText: "Cancelar",
    }).then((r) => {
      if (r.isConfirmed) {
        axios.post(`${URL_TURNOS}Seed`, {}, headers)
          .then(() => { Swal.fire("Listo!", "Turnos cargados", "success"); window.location.reload(); })
          .catch((error) => Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!", footer: `${error.response ? error.response.data : error}` }));
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "catalogos.turnos.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-clock" style={{ marginRight: 8, color: "#f59e0b" }} />
                  Turnos
                </h3>
                <p className="page-subtitle">Turnos de producción</p>
              </div>
              <div className="page-actions">
                {turnos.length === 0 && (
                  <Button size="sm" color="info" onClick={sembrar} style={{ marginRight: 8 }}>
                    <i className="fas fa-magic" style={{ marginRight: 6 }} /> Cargar turnos por defecto
                  </Button>
                )}
                {puede(user, "catalogos.turnos.crear") && (
<Button size="sm" color="success" onClick={abreNuevo}>
                  <i className="fas fa-plus" style={{ marginRight: 6 }} /> Nuevo Turno
                </Button>
)}
              </div>
            </div>
            <Table size="sm" striped borderless className="table-responsive-xl table-dark-header">
              <thead>
                <tr>
                  <th className="tituloTabla">Turno</th>
                  <th className="tituloTabla">Inicio</th>
                  <th className="tituloTabla">Fin</th>
                  <th className="tituloTabla">Editar</th>
                </tr>
              </thead>
              <tbody>
                {turnos.map((a) => (
                  <tr key={a._id}>
                    <td>{a.nombre}</td>
                    <td>{a.horaInicio}</td>
                    <td>{a.horaFin}</td>
                    <td>
                      {puede(user, "catalogos.turnos.editar") && (
<Button color="info" size="sm" onClick={() => abreEdit(a)}>
                        <i className="far fa-edit"></i>
                      </Button>
)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : undefined}
      </div>

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>
          <i className="fas fa-clock" style={{ marginRight: 8, color: "#f59e0b" }} />
          {idEdit ? "Editar" : "Nuevo"} Turno
        </ModalHeader>
        <ModalBody>
          <Label>Nombre *</Label>
          <Input type="text" value={nombre} onChange={(e) => setNombre(e.target.value)} />
          <br />
          <Row>
            <Col xs={6}>
              <Label>Inicio</Label>
              <Input type="time" value={horaInicio} onChange={(e) => setHoraInicio(e.target.value)} />
            </Col>
            <Col xs={6}>
              <Label>Fin</Label>
              <Input type="time" value={horaFin} onChange={(e) => setHoraFin(e.target.value)} />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={guardar}>
            <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoTurnos;
